import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NotificationItemDto } from "../../models/notification.models";

@Component({
  selector: "app-notification-item",
  templateUrl: "./notification-item.component.html",
  styleUrls: ["./notification-item.component.scss"],
})
export class NotificationItemComponent {
  @Input() item: NotificationItemDto | undefined;
  @Input() isItemSelected: boolean = false;

  @Output() deleteItemEvent: EventEmitter<number> = new EventEmitter<number>();
  @Output() readNotificaitonEvent: EventEmitter<NotificationItemDto> = new EventEmitter<NotificationItemDto>();

  isMore = false;

  readNotificaiton(item: NotificationItemDto) {
    this.readNotificaitonEvent.emit(item);
  }

  openDeleteItemDialog(id: number, event: MouseEvent) {
    event.stopPropagation();
    this.deleteItemEvent.emit(id);
  }

  getYear(creationDate: string) {
    return creationDate.split(" ")[0].split("-")[2];
  }
}
